import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation files
import translationEN from './locales/en.json';
import translationES from './locales/es.json';
import translationIT from './locales/it.json';
import translationFR from './locales/fr.json';
import translationDE from './locales/de.json';
import translationPT from './locales/pt.json';
import translationEU from './locales/eu.json';

const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
  it: { translation: translationIT },
  fr: { translation: translationFR },
  de: { translation: translationDE },
  pt: { translation: translationPT },
  eu: { translation: translationEU }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'es',
    supportedLngs: ['en', 'es', 'it', 'fr', 'de', 'pt', 'eu'],
    load: 'languageOnly',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'querystring', 'cookie', 'path', 'subdomain'],
      caches: ['localStorage']
    }
  });

export default i18n;
